import React from 'react';

const EmployeeErrorChart = ({ cardsetdata }) => {
  const colorClasses = ['bg-indigo-600', 'bg-violet-500', 'bg-pink-600', 'bg-orange-500', 'bg-emerald-500'];

  if (!cardsetdata || !Array.isArray(cardsetdata) || cardsetdata.length === 0) {
    return (
      <div className="panel h-full p-6 bg-white rounded-lg shadow-md">
        <div className="text-center text-gray-500">No data available</div>
      </div>
    );
  }

  const maxErrors = Math.max(...cardsetdata.map((emp) => emp.errors));

  return (
    <div className="h-full p-8 bg-white rounded-lg shadow-md overflow-auto">
      <div className="flex items-start justify-between mb-5">
        {/* <h5 className="font-semibold text-lg">Top 5 Employees Error wise</h5> */}
      </div>
      <div className="flex flex-col space-y-5">
        {cardsetdata.map((employee, index) => (
          <div key={employee.id} className="flex items-center">
            <div className="w-9 h-9">
              <div
                className={`${colorClasses[index]} rounded-full w-9 h-9 flex justify-center items-center text-white font-semibold`}
              >
                {employee.name?.charAt(0) || 'E'}
              </div>
            </div>
            <div className="px-3 flex-initial w-full">
              <div className="flex justify-between font-semibold text-gray-500 mb-1">
                <h6>
                  {employee.name || 'Employee'}-{employee.id || '0000'}
                </h6>
                <p className="ml-auto text-xs">{employee.errors || 0}</p>
              </div>
              <div>
                <div className="w-full rounded-full h-5 p-1 bg-gray-100">
                  <div
                    className={`${colorClasses[index]} h-full rounded-full relative transition-all duration-300 flex items-center`}
                    style={{ width: `${((employee.errors || 0) / maxErrors) * 100}%` }}
                  >
                    <div className="absolute right-0.5 bg-white w-2 h-2 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmployeeErrorChart;
